module.exports = __webpack_public_path__ + "static/vakif2-1b8cc31aca352754a835f9a5f2b8c07e.png";